import { Collapse } from 'bootstrap';

(function ($) {

    const updateDropdownTrigger = ($navLinks, breakpoint) => {
        if(['xs', 'sm', 'md'].includes(breakpoint)){
            $navLinks.removeAttr("data-bs-hover");
            $navLinks.attr("data-bs-toggle", "dropdown");
        }else{
            $navLinks.removeAttr("data-bs-toggle");
            $navLinks.attr("data-bs-hover", "dropdown");
        }
    }

    const resetMenuItems = ($items) => {
        $.each($items, (i, el) => { 
            $(el).removeClass('show');
            $(el).find('.dropdown-menu').removeClass('show');
        });
    }

    const showDropdown = ($el, closeSiblings = false) => {
        $el.addClass('show');
        $el.find('.nav-link').addClass('show');
        $el.find('.dropdown-menu').addClass('show');

        if(closeSiblings){
            const $siblings = $el.parent().find(".menu-item.dropdown, .menu-item.fr-has-mm").not($el);

            $siblings.removeClass('show');
            $.each($siblings, (i, el) => { 
                //$el.find('.nav-link').removeClass('show');
                $(el).find('.dropdown-menu').removeClass('show');
            });
        }

        positionLockedTopicsOverlay($el);
    }

    const hideDropdown = ($el) => {
        $el.removeClass('show');
        $el.find('.nav-link').removeClass('show');
        $el.find('.dropdown-menu').removeClass('show');
    }

    const positionLockedTopicsOverlay = ($dropdown) => {
        const $lockedTopics = $dropdown.find('.locked-topic');
        const $lockedTopicsOverlay = $dropdown.find('.locked-topics-overlay');
        const gap = 30;

        if(!$lockedTopics.length || !$lockedTopicsOverlay.length || $lockedTopicsOverlay.attr('positioned')) return;

        const topicTopOffset = $($lockedTopics[0]).offset().top;
        const overlayTopOffset = $lockedTopicsOverlay.offset().top;

        if(topicTopOffset < overlayTopOffset){
            $lockedTopicsOverlay.css('marginTop', Math.abs(parseInt(overlayTopOffset - topicTopOffset - gap)) * -1); 
        }else{
            $lockedTopicsOverlay.css('marginTop', Math.abs(parseInt(topicTopOffset - overlayTopOffset + gap))); 
        }

        $lockedTopicsOverlay.attr('positioned', true);
    }

    const lockedTopicsDropdown = ($menuContent) => {
        if($menuContent.find('.locked-topic').length){
            const $lockedTopics = $menuContent.find('.locked-topic');
            const $lockedTopicsDropdown = $lockedTopics.closest('.dropdown-menu');
            let $lockedTopicsOverlay = $menuContent.find('.locked-topics-overlay');
            let lockedTopicsLink;

            try {
                lockedTopicsLink = JSON.parse(window.fr_locked_topics_link);
            } catch (err) {
                lockedTopicsLink = false;
            }

            if(!$lockedTopicsOverlay.length && lockedTopicsLink){
                const url = lockedTopicsLink.hasOwnProperty('url') ? lockedTopicsLink.url : false;
                const title = lockedTopicsLink.hasOwnProperty('title') ? lockedTopicsLink.title : false;
                const target = lockedTopicsLink.hasOwnProperty('target') ? lockedTopicsLink.target : false;

                $lockedTopicsDropdown.append(`
                <a href="${url}" class="locked-topics-overlay" target="${target}">
                    <div>
                        ${title.replace(/\n/g, '<br>')}
                    </div>
                </a>`);

                $lockedTopicsOverlay = $menuContent.find('.locked-topics-overlay');
            }
        }
    }

    const resetLockedTopicsDropdown = ($menuContent) => {
        const $lockedTopicsOverlay = $menuContent.find('.locked-topics-overlay');
        if($lockedTopicsOverlay.length){
            $lockedTopicsOverlay.removeAttr('positioned');
            $lockedTopicsOverlay.removeAttr('style');
        }
    }

	$.fn.frHeader = function () {
		return this.each((i, el) => {
			const $self = $(el);
            const $menuContent = $('#headerMenuContent');
            const collapse = new Collapse($menuContent[0], {
                toggle: false
            });
            $self.stickyHeaderLastScrollTop = 0;
            $self.openedMegaMenuPanelParent = false;
            $self.currentBreakpoint = window.currentBreakpoint();

            $self.on('fr:trigger-close-menu', (ev) => {
                collapse.hide();
            });

            $menuContent.on('hidden.bs.collapse', (ev) => {
                $(window).trigger('fr:reset-menu-items');
                $self.removeClass('is--opened is--opening is--closing');
            });

            $menuContent.on('hide.bs.collapse', (ev) => {
                $self.removeClass('is--opened').addClass('is--closing');
            });
            
            $menuContent.on('shown.bs.collapse', (ev) => {
                $self.removeClass('is--opening').addClass('is--opened');
            });
            
            $menuContent.on('show.bs.collapse', (ev) => {
                $self.addClass('is--opening');
            });

            $menuContent.find('.dropdown-toggle').on('shown.bs.dropdown', (ev) => {
                const $target = $(ev.target);
                positionLockedTopicsOverlay($target.closest('.menu-item.dropdown'));
            });

            $(window).on('resize', () => {
                const newBreakpoint = window.currentBreakpoint();

                if(newBreakpoint !== $self.currentBreakpoint){
                    $self.currentBreakpoint = newBreakpoint;

                    updateDropdownTrigger($menuContent.find(".nav-link.dropdown-toggle"), $self.currentBreakpoint);

                    if( !['xs', 'sm', 'md'].includes($self.currentBreakpoint) ){
                        $self.trigger('fr:trigger-close-menu');
                        $self.removeClass('is--opened is--opening is--closing');
                    }
                }

                resetLockedTopicsDropdown($menuContent);
            });

            $menuContent.find(".menu-item.dropdown").on({
                mouseenter: function(){
                    const $el = $(this);
                    if(!['xs', 'sm', 'md'].includes($self.currentBreakpoint)){
                        showDropdown($el, true);
                        $self.openedMegaMenuPanelParent = $el.hasClass('fr-has-mm') ? $el : false;
                    }
                },
                mouseleave: function(){
                    const $el = $(this);
                    if(!['xs', 'sm', 'md'].includes($self.currentBreakpoint)){
                        setTimeout(() => {
                            if(!$self.openedMegaMenuPanelParent){
                                hideDropdown($el);
                                $self.openedMegaMenuPanelParent = false;
                            }
                        }, 300);
                    }
                }
            });

            $(window).on('fr:reset-menu-items', () => {
                resetMenuItems($menuContent.find(".menu-item.dropdown"));
            });

            //on page load
            updateDropdownTrigger($menuContent.find(".nav-link.dropdown-toggle"), $self.currentBreakpoint);

            lockedTopicsDropdown($menuContent);

		});
	}

	$(() => {
		$('header.fr-header').frHeader();
	});
})($);